import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {ComponentContainer, Spinner, StyledSmallTitle, Center, MembersTitle} from './shared/styles';
import {Query} from 'react-apollo';
import {privateCompanyStacks} from '../../../data/tool-profile/queries';
import {MobileContext} from '../../../shared/enhancers/mobile-enhancer';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import {updateQuery} from '../utils';
import NavAnchor, {NAV_ANCHOR_OFFSET} from './shared/nav-anchor';
import glamorous from 'glamorous';
import StackCard from '../../../shared/library/cards/stack/stack-card';
import LoadMoreButton from '../../../shared/library/buttons/load-more';
import {PHONE} from '../../../shared/style/breakpoints';
import PrivatePublicIndicator from '../../../shared/library/private-public-indicator';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const Container = glamorous.div({
  display: 'grid',
  gridGap: 20,
  gridTemplateColumns: `1fr 1fr 1fr`,
  [PHONE]: {
    gridTemplateColumns: `1fr`
  },
  margin: '25px 0'
});

const PrivateStacks = ({tool, privateCompanyName}) => {
  const isMobile = useContext(MobileContext);
  return (
    <ComponentContainer>
      <NavAnchor id="stacks" offset={NAV_ANCHOR_OFFSET} />
      <Query
        query={privateCompanyStacks}
        variables={{id: tool.id, first: isMobile ? 2 : 6}}
        notifyOnNetworkStatusChange={true}
      >
        {({loading, data, fetchMore}) => {
          const hasData = data && data.tool && data.tool.privateCompanyStacks.count !== 0;
          if (loading && !hasData)
            return (
              <Spinner>
                <Circular size={LARGE} />
              </Spinner>
            );

          if (hasData) {
            const endCursor = data.tool.privateCompanyStacks.pageInfo.endCursor;
            const hasNextPage = data.tool.privateCompanyStacks.pageInfo.hasNextPage;
            const count = data.tool.privateCompanyStacks.count;

            const onLoadMoreClick = () => {
              fetchMore({
                variables: {
                  after: endCursor,
                  first: isMobile ? 2 : 6
                },
                updateQuery
              });
            };

            return (
              <>
                <MembersTitle>
                  <StyledSmallTitle>{`${count} Stacks at ${privateCompanyName} that use ${
                    tool.name
                  }`}</StyledSmallTitle>
                  <PrivatePublicIndicator typeIndicator="BlueRoundLarge" />
                </MembersTitle>
                <Container>
                  {data.tool.privateCompanyStacks.edges.map(items => (
                    <StackCard
                      key={items.node.id}
                      name={items.node.name}
                      count={items.node.services.length}
                      services={items.node.services}
                      path={items.node.path}
                      isPrivate={items.node.private}
                      repoStack={items.node.repoStack}
                      isOwner={items.node.owner.amIOwner}
                    />
                  ))}
                </Container>
                {hasNextPage && (
                  <Center>
                    <LoadMoreButton loading={loading} onClick={onLoadMoreClick} />
                  </Center>
                )}
              </>
            );
          } else return null;
        }}
      </Query>
    </ComponentContainer>
  );
};

PrivateStacks.propTypes = {
  tool: PropTypes.object,
  privateCompanyName: PropTypes.string
};

export default withErrorBoundary(true)(PrivateStacks);
